<!-- Header -->
<app-header />

<!-- Main Content -->
<main class="min-h-[calc(100svh-80px)]">
  <router-outlet />
</main>
<!-- Footer -->
<app-footer />
